import { css } from '@emotion/css';

export const picklistStyles = css`
  .MuiOutlinedInput-root {
    flex-wrap: nowrap;
  }

  .MuiOutlinedInput-input {
    min-width: unset;
  }
`;
